<template>
  <span v-if="servico.tagComplemento">
    <div class="mr-50 tags">
      <a
        v-b-tooltip.hover
        class="badge badge-outline-primary link"
        style="font-size: 12.5px;"
        :title="servico.tagComplemento"
        @click="editarTag(servico)"
      >
        <strong>{{ servico.tagComplemento }}</strong>
      </a>
      <b-btn
        v-if="true"
        class="btn-primary btn-sm py-0 px-1 remove"
        variant="none"
        @click="removeTag(servico)"
      >
        <feather-icon
          style=""
          icon="TrashIcon"
        />
      </b-btn>
    </div>
  </span>
</template>

<script>
export default {
  name: 'TagComplementoServico',
  props: {
    servico: {
      type: Object,
      default: null,
    },
  },
  methods: {
    editarTag(servico) {
      this.$emit('editar-tag', servico)
    },
    removeTag(servico) {
      this.$emit('remover-tag', servico)
    },
  },
}
</script>
